import { cloneDeep } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';

import { saveDocument, validatePagesCountValue, updateDocument } from '../../../../actions/actions';
import { Tab, Tabs } from '../../../Tabs';
import { IBranding, ICrop, IDocument, ILogo, ICoverImage, IState, IUserData, IPostcardImage, IPosterImage, ITagline } from './../../../../infrastructure/interfaces';
import { IWizardProps } from './../../../Wizard/Wizard';
import BrandingEditor from './BrandingEditor';
import CoverImageEditor from './CoverImageEditor';
import BrandingListEditor from './BrandingListEditor';
import CompanyInfoEditor from './CompanyInfoEditor';
import CropsEditor from './CropsEditor';
import LogoEditor from './LogoEditor';
import AdditinalInfoEditor from './AdditinalInfoEditor';
import PostcardImageBack from './PostcardImageBackEditor'
import PostcardImageFront from './PostcardImageFrontEditor'
import PosterImageBackground from './PosterImageBackgroundEditor'
import TaglineEditor from './TaglineEditor'

export interface ISettingsProps {
  brandings?: IBranding[];
  coverImages?: ICoverImage[];
  postcardImages?: IPostcardImage[];
  posterImagesList?: IPosterImage[];
  brandingList?: IBranding[];
  logos?: ILogo[];
  crops?: ICrop[];
  document?: IDocument;
  userData: IUserData;
  wizard?: IWizardProps;
  statesList?: IState[];
  taglines: ITagline[];
  saveDocument?(document: IDocument, userID: string, redirect?: string): void;
  updateDocument?(pagesCount: number, userID: string): void;
  validatePagesCountValue?(value: number): void;
}

export interface ISettingsState extends React.ComponentState {
  document: IDocument;
  wizard: IWizardProps;
}

const mapStateToProps = (state: any): any => {
  return {
    brandings: state.wizard.brandings,
    coverImages: state.wizard.coverImages,
    postcardImages: state.wizard.postcardImages,
    posterImagesList: state.wizard.posterImages,
    brandingList: state.wizard.brandings,
    crops: state.wizard.crops,
    logos: state.wizard.logos,
    document: state.document,
    userData: state.user.data,
    wizard: state.wizard,
    statesList: state.statesList,
    taglines: state.wizard.taglines,
  };
};
const mapDispatchToProps = (dispatch: any): any => {
  return {
    validatePagesCountValue: (value: number): void => {
      dispatch(validatePagesCountValue(value));
    },
    saveDocument: (document: IDocument, userID: string, redirect?: string): void => {
      dispatch(saveDocument(document, userID, redirect));
    },
    updateDocument: (pagesCount: number, userID: string): void => {
      dispatch(updateDocument(pagesCount, userID));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class Settings extends React.Component<ISettingsProps, ISettingsState> {

  constructor(props: any) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
      wizard: cloneDeep(props.wizard),
    };
  }

  updateModelDocument = (document: IDocument): void => {
    this.setState({
      document,
    });
  }

  saveDocument = (document: IDocument): void => {
    this.setState({ document });
    if (this.props.saveDocument != undefined) {
      this.props.saveDocument(document, this.props.userData.id);
    }
  }
  
  validatePagesCountValue = (value: any) => {

    if (this.props.validatePagesCountValue != undefined) {
      this.props.validatePagesCountValue(value);
    }
  }

  cancelDocument = () => {
    this.setState({
      document: this.props.document!,
    });
  }

  renderTop() {
    return <div className="product-container__title"><span>Click options in left margin to change settings.</span></div>;
  }

  additionalInfoTabTitle() {
    if (this.state.document.type === "Postcard"){
      return "Optional Message for Back of Postcard"
    } if (this.state.document.type === "Poster") {
      return "Title for Poster"
    } else {
      return "Optional Cover Subtitle"
    }
  } 

  render() {
    const currentTab = this.state.document.type === 'Bulletin' ? 3 : 0;
    const usesCoverPhoto = (this.state.document.type !== 'Postcard') && (this.state.document.type !== 'Bulletin') && (this.state.document.type !== 'Poster');
    return (
      <Tabs
        tabsWrapperClassName="content settingsContent"
        tabHeaderClassName="sidePane"
        tabClassName="settingsTab"
        activeTabClassName="settingsTab activeSettingsTab"
        tabBodyClassName="settingsContentContainer"
        tabsContainerClassName="settingsTabContainer"
        currentTab={currentTab}
        renderToBody={this.renderTop}
      >
      {usesCoverPhoto ?
        <Tab title="Cover Background Image">
          <CoverImageEditor
            document={this.state.document}
            taglines={this.props.taglines}
            userData={this.props.userData}
            coverImages={this.props.coverImages!}
            saveDocument={this.saveDocument}
            updateModelDocument={this.updateModelDocument}
            cancelDocument={this.cancelDocument}
          />
        </Tab> : null}
        {usesCoverPhoto ?
          <Tab title="Cover Tagline">
            <TaglineEditor
              document={this.state.document}
              taglines={this.props.taglines}
              userData={this.props.userData}
              saveDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab> : null}
        {usesCoverPhoto ? 
          <Tab title="Crops for Cover Photos">
            <CropsEditor
              document={this.state.document}
              userData={this.props.userData}
              crops={this.props.crops!}
              updateDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab> : null}
        {usesCoverPhoto ? 
          <Tab title="Front Cover Branding">
            <BrandingEditor
              document={this.state.document}
              userData={this.props.userData}
              brandings={this.props.brandings!}
              saveDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab> : null}
        {(this.state.document.type !== 'Postcard') && (this.state.document.type !== 'Poster') ?
          <Tab title={`${this.state.document.type !== 'Bulletin' ? 'Back Cover Branding' : 'Footer Branding'}`}>
            <BrandingListEditor
              document={this.state.document}
              userData={this.props.userData}
              brandingsList={this.props.brandingList!}
              updateDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
        </Tab> : null }
        {(this.state.document.type !== 'Postcard') && (this.state.document.type !== 'Bulletin') && (this.state.document.type !== 'Poster') ? 
        <Tab title="Back Cover Co-branding">
          <LogoEditor
            document={this.state.document}
            userData={this.props.userData}
            logos={this.props.logos!}
            updateDocument={this.saveDocument}
            updateModelDocument={this.updateModelDocument}
            cancelDocument={this.cancelDocument}
          />
        </Tab> : null}
        {(this.state.document.type !== 'Poster') ?
          <Tab title="Company Information">
            <CompanyInfoEditor
              document={this.state.document}
              userData={this.props.userData}
              updateDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab> :null }
        {this.state.document.type === 'Postcard' ?
          <Tab title="Back of Postcard Background">
            <PostcardImageBack
              document={this.state.document}
              postcardImages={this.props.postcardImages!}
              userData={this.props.userData}
              saveDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab>
          : null}
        {this.state.document.type === 'Postcard' ?
          <Tab title="Front of Postcard Background">
            <PostcardImageFront
              document={this.state.document}
              postcardImages={this.props.postcardImages!}
              userData={this.props.userData}
              saveDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab>
          : null}
        {this.state.document.type === 'Poster' ?
          <Tab title="Poster Background Image">
            <PosterImageBackground 
              document={this.state.document}
              posterImagesList={this.props.posterImagesList!}
              userData={this.props.userData}
              saveDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab>
          : null}
        {(this.state.document.type !== 'Bulletin') ?
          <Tab title={this.additionalInfoTabTitle()}>
            <AdditinalInfoEditor
              document={this.state.document}
              userData={this.props.userData}
              updateDocument={this.saveDocument}
              updateModelDocument={this.updateModelDocument}
              cancelDocument={this.cancelDocument}
            />
          </Tab>
          : null}
      </Tabs>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/Settings.tsx